import { ProjectProps } from "@/interfaces/project_types";
import { ProjectCard } from "../Cards/ProjectCard";
import { SectionDivRow } from "./Components/SectionDivRow";
import { SectionDiv } from "./Components/SectionDiv";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

type ProjectSectionProps = {
    sorted_projects: ProjectProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void,
}

export function ProjectSection(
    { sorted_projects, isNewCard, markAsSeen }: ProjectSectionProps
) {
    const [isMini, setIsMini] = useState(false)

    const onMiniClick = () => {
        const newIsMini = !isMini
        setIsMini(newIsMini)
        localStorage.setItem('project_section_mini', newIsMini.toString())
    }

    useEffect(() => {
        const storedMini = localStorage.getItem('project_section_mini')
        console.log(storedMini)
        if (storedMini) {
            setIsMini(storedMini === 'true')
        }
    }, [])
    return (
        <SectionDiv>
            <ProjectHeader isMini={isMini} onClick={onMiniClick} />

            <SectionDivRow>
                {sorted_projects.length > 0 ? sorted_projects.map((project) => (
                    project.status === "Completed" ? null :
                        <ProjectCard
                            key={project.project_id}
                            project={project}
                            isNew={isNewCard('project', project.project_id ?? '')}
                            isMini={isMini}
                            onView={() => markAsSeen('project', project.project_id ?? '')} />
                ))
                    :
                    <h3>No Projects assigned to you</h3>}
            </SectionDivRow>
        </SectionDiv>
    );
}
function ProjectHeader({isMini, onClick }: { isMini: boolean, onClick: () => void }) {
    return (
        <div className="flex flex-row justify-between items-center">
            <h3>My Projects:</h3>
            <MiniButton onClick={onClick} isMini={isMini} />
        </div>
    )
}

function MiniButton({ onClick, isMini }: { onClick: () => void, isMini: boolean }) {
    return (
        <Button onClick={onClick} variant="outline" className="text-xs">
            {isMini ? 'View All' : 'View Mini'}
        </Button>
    )
}